import PropTypes from "prop-types";
import RadioButton from "@shared/v2/RadioButton";

const STYLES = {
  basicBorder: "tw-border-1px tw-border-solid tw-border-gray-10",
}

const AddressBlock = ({ streetAddress, city, locality, postalCode, title, country, checked, recommended, onClick }) => (
  <div
    className={`${STYLES.basicBorder} tw-px-16px tw-py-8px tw-border-b-1px tw-flex tw-items-center tw-gap-16px`}
    onClick={onClick}
    role="button"
    tabIndex={0}
    onKeyDown={e => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        onClick(e);
      }
    }}
    aria-pressed={checked}
  >
    <RadioButton checked={checked} containerClassName='tw-w-16px' />
    <div className="tw-text-text-gray-75 tw-flex-1">
      <b>{title}</b>
      <div className={checked ? 'tw-text-theme-text-button-color tw-font-bold' : ''}>{streetAddress}</div>
      <div>{[city, locality, postalCode, country]
        .filter(Boolean)
        .join(', ')}</div>
    </div>
    {recommended && <i>Recommended</i>}
  </div>
)

const VerifyAddressModalBody = ({ suggestedAddress, originalAddress, isSuggestedAddress, setIsSuggestedAddress }) => {
  return (
    <div className="tw-flex tw-flex-col tw-gap-16px">
      <span className="tw-text-gray-75 tw-text-14d"><b>The address you’ve entered uses a non-standard format.</b> Saving it as-is may impact features like mailers, home value estimates, and more.</span>
      <div className={`${STYLES.basicBorder} tw-rounded-8px`}>
        <AddressBlock
          streetAddress={`${suggestedAddress?.streetAddress}${suggestedAddress?.secondaryAddress ? `, ${suggestedAddress?.secondaryAddress}` : ''}`}
          city={suggestedAddress?.city}
          locality={suggestedAddress?.locality}
          postalCode={suggestedAddress?.postalCode}
          country={suggestedAddress?.country}
          title="Suggested Address"
          checked={isSuggestedAddress}
          recommended
          onClick={() => setIsSuggestedAddress(true)}
        />
        <AddressBlock
          streetAddress={`${originalAddress?.streetAddress}${originalAddress?.secondaryAddress ? `, ${originalAddress?.secondaryAddress}` : ''}`}
          city={originalAddress?.city}
          locality={originalAddress?.locality}
          postalCode={originalAddress?.postalCode}
          country={originalAddress?.country}
          title="Original Address"
          checked={!isSuggestedAddress}
          onClick={() => setIsSuggestedAddress(false)}
        />
      </div>
    </div>
  )
};

export default VerifyAddressModalBody;

const addressProp = {
  streetAddress: PropTypes.string,
  secondaryAddress: PropTypes.string,
  city: PropTypes.string,
  locality: PropTypes.string,
  postalCode: PropTypes.string,
  country: PropTypes.string,
}

VerifyAddressModalBody.propTypes = {
  suggestedAddress: PropTypes.shape(addressProp).isRequired,
  originalAddress: PropTypes.shape(addressProp).isRequired,
  isSuggestedAddress: PropTypes.bool.isRequired,
  setIsSuggestedAddress: PropTypes.func.isRequired,
}

AddressBlock.propTypes = {
  streetAddress: PropTypes.string,
  city: PropTypes.string,
  locality: PropTypes.string,
  postalCode: PropTypes.string,
  country: PropTypes.string,
  checked: PropTypes.bool,
  recommended: PropTypes.bool,
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

AddressBlock.defaultProps = {
  streetAddress: "",
  city: "",
  locality: "",
  postalCode: "",
  country: "",
  checked: false,
  recommended: false,
};